// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeroTile_wrapper__J9ugE","image":"HeroTile_image__zlJ37","title":"HeroTile_title__4lwst"};